import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ImageType } from '@models/Image';

const useDownloadImage = (fileNameBase: string, imageType: ImageType, src: string) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const downloadImage = () => {
    setLoading(true);

    fetch(src)
      .then(response => response.blob())
      .then(blob => {
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;

        const filename = `${fileNameBase} [${t('imageType', {
          context: imageType,
        })}]`;

        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      })
      .finally(() => setLoading(false));
  };

  return {
    loading,
    downloadImage,
  };
};

export default useDownloadImage;
